import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';


const SCLogoImage = styled('img')(() => ({
  display: 'block',
  width: '272px',
  height: '48px',
}));


interface NewHFLHeaderProps {
  contentMaxWidth?: string;
}

function NewHFLHeader({ contentMaxWidth }: NewHFLHeaderProps) {
  const originHost = window.location.origin;

  const appBarStyle = {
    boxShadow: 'none',
    backgroundColor: 'transparent',
  };

  const toolbarStyle = {
    width: '100%',
    maxWidth: contentMaxWidth || 'none',
    margin: contentMaxWidth ? '0 auto' : 0,
    paddingLeft: {
      xs: '20px',
      sm: contentMaxWidth ? '40px' : '20px',
      md: '80px',
      lg: contentMaxWidth ? 0 : '80px',
    },
    paddingRight: {
      xs: '20px',
      sm: contentMaxWidth ? '40px' : '20px',
      md: '80px',
      lg: contentMaxWidth ? 0 : '80px',
    },
    paddingTop: { xs: '8px', sm: '16px' },
    paddingBottom: { xs: '8px', sm: '16px' },
    minHeight: { xs: '64px', sm: '80px' },
  };

  const logoLinkStyle = {
    display: 'inline-flex',
    flexShrink: 0,
  };

  return (
    <AppBar position="static" sx={appBarStyle}>
      <Toolbar disableGutters sx={toolbarStyle}>
        <Box component="a" href="/candidate-profile" aria-label="Heidrick for Leaders home" sx={logoLinkStyle}>
          <SCLogoImage src={originHost + '/res/hd-ui-kit-images/heidrickForLeadersLogo.svg'} alt="Heidrick for Leaders" />
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default NewHFLHeader;
